"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var GochainErc20TransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(GochainErc20TransactionRequest, _super);
    function GochainErc20TransactionRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GochainErc20TransactionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.GochainErc20TransactionRequest = GochainErc20TransactionRequest;
//# sourceMappingURL=GochainErc20TransactionRequest.js.map